import { createSlice } from "@reduxjs/toolkit";
import {
  getFeedNameList,
  getPropertiesQualifyForHabi,
  postSaveHistory,
  postSendWhatsApp,
} from "./qualifyForHabi.thunks";
import { QualifyPropertyList } from "./qualifyForHabi.types";

const today = new Date();
const week = 1000 * 60 * 60 * 24 * 7;
const lastWeek = new Date(today.getTime() - week);

export const initialStateQualify: QualifyPropertyList = {
  result: [],
  filters: {
    leads_count: 100,
    city_id: [],
    broker_type: [],
    date_end: today.toISOString(),
    date_init: lastWeek.toISOString(),
    price_max: "52000000",
    price_min: "0",
    property_exported: "3",
    user_exported: "3",
    is_interested: "3",
    offer_from_whatsapp: 3,
    zone_classification: []
  },
  exportOptions: {
    source: null,
    status: 2,
  },
  filtersRequest: {},
  loading: false,
  rows_selected: [],
  rows_selected_whatsapp: [[]],
  open_modal_confimation: false,
  modal_message: "",
  loading_whatsapp: false,
  municipalities: [],
  unique_values_count: 0,
  messages_sended: 0,
  messages_error: 0,
  proccess_ended: false,
  feed_name_list: [],
  loading_feed: false
};

const qualifyForHabiSlice = createSlice({
  name: "qualify",
  initialState: initialStateQualify,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setRowsSelected: (state, action) => {
      state.rows_selected = action.payload;
    },
    setMunicipalities: (state, action) => {
      state.municipalities = action.payload;
    },
    setFiltersRequest: (state, action) => {
      state.filtersRequest = action.payload;
    },
    setRowsSelectedWhatsapp: (state, action) => {
      state.rows_selected_whatsapp = action.payload;
    },
    setShowWhatsAppConfirmation: (state, action) => {
      state.open_modal_confimation = action.payload.open;
      state.modal_message = action.payload.message;
      state.loading_whatsapp = action.payload.loading_whatsapp;
    },
    setUniqueValuesCount: (state, action) => {
      state.unique_values_count = action.payload;
    },
    setExportOptions: (state, action) => {
      state.exportOptions = action.payload;
    },
    setProccessEnded: (state, action) => {
      state.proccess_ended = action.payload;
    },
    setFeedName: (state, action) => {
      state.feed_name_list = action.payload;
    },
    setMessagesSended: (state, action) => {
      state.messages_sended = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPropertiesQualifyForHabi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getPropertiesQualifyForHabi.fulfilled, (state, action) => {
      state.result = action.payload.result;
      state.loading = false;
    });
    builder.addCase(getPropertiesQualifyForHabi.rejected, (state, action) => {
      state.loading = false;
      state.open_modal_confimation = true;
      state.modal_message = "Error al cargar los datos.";
    });
    builder.addCase(postSaveHistory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(postSaveHistory.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(postSaveHistory.rejected, (state) => {
      state.loading = false;
      state.open_modal_confimation = true;
      state.modal_message = "Error en el servicio de guardar historial.";
    });
    builder.addCase(postSendWhatsApp.pending, (state) => {
      state.loading_whatsapp = true;
    });
    builder.addCase(postSendWhatsApp.fulfilled, (state, action) => {
      state.messages_sended = state.messages_sended + action.payload.sent_wa_offers.succeded.length
      state.messages_error = state.messages_error + action.payload.sent_wa_offers.failed.length
      state.modal_message = `Enviados ${state.messages_sended} mensajes de ${state.rows_selected_whatsapp.length}`
    });
    builder.addCase(postSendWhatsApp.rejected, (state, action) => {
      console.log("🚀 ~ builder.addCase ~ action:", action.error)
    });
    builder.addCase(getFeedNameList.pending, (state) => {
      state.loading_feed = true
    });
    builder.addCase(getFeedNameList.fulfilled, (state, action) => {
      state.feed_name_list = action.payload.feed_names
      state.loading_feed = false
    });
  },
});
export const {
  setFilters,
  setRowsSelected,
  setMunicipalities,
  setFiltersRequest,
  setRowsSelectedWhatsapp,
  setShowWhatsAppConfirmation,
  setUniqueValuesCount,
  setExportOptions,
  setProccessEnded,
  setFeedName,
  setMessagesSended,
} = qualifyForHabiSlice.actions;

export default qualifyForHabiSlice.reducer;
